export default {
  mounted() {
    const up = document.getElementById('accordionDrawing-up')
    const down = document.getElementById('accordionDrawing-down')
    up.classList.add('is-hide')
    down.classList.add('is-show')

    $('.accordionDrawing').on('show.bs.collapse', function() {
      const up = document.getElementById('accordionDrawing-up')
      const down = document.getElementById('accordionDrawing-down')
      up.classList.add('is-show')
      up.classList.remove('is-hide')
      down.classList.remove('is-show')
      down.classList.add('is-hide')
      localStorage.isSearchShow = 1
    })
    $('.accordionDrawing').on('hide.bs.collapse', function() {
      const up = document.getElementById('accordionDrawing-up')
      const down = document.getElementById('accordionDrawing-down')
      up.classList.remove('is-show')
      up.classList.add('is-hide')
      down.classList.add('is-show')
      down.classList.remove('is-hide')
      localStorage.isSearchShow = 0
    })
    if (~~localStorage.isSearchShow) {
      $('.accordionDrawing').collapse('show')
    } else {
      $('.accordionDrawing').collapse('hide')
    }
  },
}